'use client';

// https://21st.dev/aceternity/layout-grid/default
import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, m } from 'motion/react';
import Image from 'next/image';
import React, { useRef, useState } from 'react';
import { cn } from '@/lib/utils';
import { ProgressiveBlur } from './progressive-blur';
type Card = {
  id: number;
  content: React.ReactElement | React.ReactNode | string;
  className: string;
  thumbnail: string;
  alt?: string;
};
export const LayoutGrid = t0 => {
  const $ = _c(8);
  const {
    cards
  } = t0;
  const [selected, setSelected] = useState(null);
  const lastSelectedRef = useRef(null);
  const handleClick = card => {
    lastSelectedRef.current = selected;
    setSelected(() => card);
  };
  const handleOutsideClick = () => {
    lastSelectedRef.current = selected;
    setSelected(null);
  };
  const t1 = "relative mx-auto grid w-full grid-cols-1 gap-6 md:grid-cols-3";
  const t2 = cards.map(card_0 => <div key={card_0.id} className={cn(card_0.className)}><m.div onClick={() => handleClick(card_0)} className={cn("relative overflow-hidden rounded-2xl", selected?.id === card_0.id ? "fixed inset-0 z-50 m-auto flex h-auto max-w-4xl cursor-pointer items-center justify-center" : "bg-zinc-100 dark:bg-zinc-800")} layoutId={`card-${card_0.id}`}>{selected?.id === card_0.id && <SelectedCard selected={selected} />}<ImageComponent card={card_0} isSelected={selected?.id === card_0.id} /></m.div></div>);
  let t3;
  if ($[0] !== handleOutsideClick || $[1] !== selected) {
    t3 = selected && <m.div onClick={handleOutsideClick} initial={{
      opacity: 0
    }} animate={{
      opacity: 0.7
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-40 cursor-pointer bg-neutral-950" />;
    $[0] = handleOutsideClick;
    $[1] = selected;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <AnimatePresence>{t3}</AnimatePresence>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <div className={t1}>{t2}{t4}</div>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
const ImageComponent = t0 => {
  const $ = _c(6);
  const {
    card,
    isSelected
  } = t0;
  const t1 = card.thumbnail;
  const t2 = card.alt || "Project image";
  const t3 = isSelected ? "max-h-[80vh] object-contain" : "object-cover";
  let t4;
  if ($[0] !== t3) {
    t4 = cn("size-full rounded-2xl", t3);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== card.thumbnail || $[3] !== t2 || $[4] !== t4) {
    t5 = <div className="size-full"><Image src={t1} alt={t2} width={800} height={600} className={t4} /></div>;
    $[2] = card.thumbnail;
    $[3] = t2;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
const SelectedCard = t0 => {
  const $ = _c(8);
  const {
    selected
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ProgressiveBlur direction="bottom" blurLayers={8} blurIntensity={0.4} className="absolute inset-0 size-full" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `content-${selected?.id}`;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      y: 100
    };
    t4 = {
      opacity: 1,
      y: 0
    };
    t5 = {
      opacity: 0,
      y: 100
    };
    t6 = {
      duration: 0.3,
      ease: "easeInOut"
    };
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
  }
  const t7 = selected?.content;
  let t8;
  if ($[5] !== t2 || $[6] !== t7) {
    t8 = <div className="relative z-[60] flex w-full flex-col justify-end rounded-lg bg-transparent">{t1}<m.div layoutId={t2} initial={t3} animate={t4} exit={t5} transition={t6} className="relative z-[70] px-8 pb-8">{t7}</m.div></div>;
    $[5] = t2;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  return t8;
};